export enum Messages {
  ReloadDocuments = "reload_documents",
  ReloadProjectStats = "reload_project_stats"
}
